import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

// Keyed by location.key (a stable per-history-entry id React Router assigns),
// so going back to an entry looks up the scroll position recorded for that
// exact entry, not just the pathname (two visits to the same path get
// different keys and can have different scroll positions).
const scrollPositions = new Map();

export function ScrollToTop() {
  const { pathname, hash, key } = useLocation();
  const navigationType = useNavigationType();

  // Continuously record scroll position against the current entry's key so
  // it's available if the user later navigates back to it.
  useEffect(() => {
    const onScroll = () => scrollPositions.set(key, window.scrollY);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [key]);

  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
      return;
    }

    // POP = browser back/forward — restore where the user was, if known.
    // PUSH/REPLACE = a normal link click to a new page — start at the top.
    if (navigationType === 'POP' && scrollPositions.has(key)) {
      window.scrollTo({ top: scrollPositions.get(key), behavior: 'instant' });
    } else {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [pathname, hash, key, navigationType]);

  return null;
}
